import { DataGrid } from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import { DeleteOutline, Search, Add, Remove } from '@mui/icons-material'
import { databaseLocation } from '../../dummyData'
import { Link, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Axios from 'axios'
import Dropdown from '../../components/Dropdown'
import { useLog } from '../../contexts/LogContext'
import { Stack, IconButton, Tooltip } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import SearchIcon from '@mui/icons-material/Search'
import TravelExploreIcon from '@mui/icons-material/TravelExplore' // NEW
import StorefrontIcon from '@mui/icons-material/Storefront' // eBay
import HandymanIcon from '@mui/icons-material/Handyman' // MD-Teile
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled' // KFZ24
import { Badge } from '@mui/material'
import api from "../../axios"

export default function ProductList({ user }) {
	const [articleList, setArticleList] = useState([])
	const [filteredList, setFilteredList] = useState([])
	const [searchText, setSearchText] = useState('')
	const [selectedFilters, setSelectedFilters] = useState([])
	const { createLogEntry } = useLog()

	const location = useLocation()

	const [loading, setLoading] = useState(true)

	useEffect(() => {
		let isMounted = true
		setLoading(true)
		Axios.get(`${databaseLocation}/product/`)
			.then((response) => {
				if (!isMounted) return
				setArticleList(response.data)
				setFilteredList(response.data)
				if (location.pathname.split('/').length > 2) {
					setSearchText(location.pathname.split('/')[2])
				}
			})
			.catch(console.log)
			.finally(() => isMounted && setLoading(false))
		return () => {
			isMounted = false
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const handleFilter = (value) => {
		if (value.length < 1) {
			setSelectedFilters([])
			setFilteredList(articleList)
		} else {
			if (!selectedFilters.includes(value)) {
				setSelectedFilters([...selectedFilters, value])
			} else {
				setSelectedFilters(selectedFilters.filter((option) => option != value))
			}
			let tempList = articleList
			if (value.includes('NotOnEbay')) {
				tempList = tempList.filter((article) => article.onEbay == 0)
			}
			if (value.includes('WithPicture')) {
				tempList = tempList.filter((article) => article.URL.length > 3)
			}
			if (value.includes('WithoutPicture')) {
				tempList = tempList.filter((article) => article.URL.length < 3)
			}
			if (value.includes('NoRegulator')) {
				tempList = tempList.filter(
					(article) => !article.articleType.toLowerCase().includes('regulator')
				)
			}
			if (value.includes('InStock')) {
				tempList = tempList.filter((article) => article.quantity > 0)
			}
			setFilteredList(tempList)
		}
	}

	/** Search Handler **/
	useEffect(() => {
		const searchTxt = searchText.toLowerCase().replaceAll(' ', '')
		setFilteredList(
			articleList.filter(
				(article) =>
					article.articleNumber.replaceAll(' ', '').toLowerCase().includes(searchTxt) ||
					article.oe.replaceAll(' ', '').toLowerCase().includes(searchTxt)
			)
		)

		if (searchText.length > 3) {
			createLogEntry(`searched for article "${searchText}"`)
		}
	}, [searchText]) // eslint-disable-line react-hooks/exhaustive-deps

	const buildPshUrl = (num) =>
		`https://psh.eu/en/search-results/?searched_type=start&q=${encodeURIComponent(
			num || ''
		)}&search+form+submit=&Brand=&product_group=&kntype=&kntype-number=`

	const buildKfz24Url = (num, type) => {
		const t = (type || '').toLowerCase()
		if (/alternator|lichtmaschine/.test(t)) {
			return `https://www.kfzteile24.de/ersatzteile-verschleissteile/elektrik/generator/generator-lichtmaschine?notTypeSearch=${encodeURIComponent(
				num || ''
			)}`
		}
		if (/starter|anlasser/.test(t)) {
			return `https://www.kfzteile24.de/artikelsuche?search=${encodeURIComponent(
				num || ''
			)}&searchType=artnrOenr`
		}
		return null // unbekannter Typ -> Button optional ausblenden/disable
	}

	const columns = [
		{ field: 'articleType', headerName: 'Type', minWidth: 150, flex: 1, resizable: true },
		{ field: 'brand', headerName: 'Brand', minWidth: 100, flex: 1, resizable: true },
		{ field: 'power', headerName: 'Power', minWidth: 80, flex: 0.5 },
		{ field: 'storagePlace', headerName: 'Place', minWidth: 120, flex: 0.8 },
		{ field: 'quantity', headerName: 'Qty', minWidth: 80, flex: 0.5 },
		{ field: 'articleNumber', headerName: 'Article', minWidth: 150, flex: 1 },
		{
			field: 'manufacturer',
			headerName: 'Manufacturer',
			minWidth: 120,
			flex: 0.8,
		},
		{
			field: 'ebayPlus',
			headerName: 'Price',
			minWidth: 100,
			numeric: true,
			flex: 0.8,
		},
		{
			field: 'onEbay',
			headerName: 'onEbay',
			minWidth: 80,
			flex: 0.8,
			sortable: true,
			filterable: false,
			renderCell: (params) => {
				const num = params.row.articleNumber
				const hasNum = !!num
				const count = Number(params.value || 0)

				return (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'start',
							justifyContent: 'start',
							width: '100%',
						}}>
						<Tooltip title='eBay Suche'>
							<span>
								<Badge
									badgeContent={count}
									color={count > 0 ? 'success' : 'default'}
									overlap='circular'
									anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
									sx={{
										'& .MuiBadge-badge': {
											fontSize: 10,
											height: 16,
											minWidth: 16,
											px: 0.5,
										},
									}}>
									<IconButton
										size='small'
										disabled={!hasNum}
										sx={{
											p: 0.5,
											bgcolor: '#e6f0ff',
											color: '#0047a6',
											boxShadow: 1,
											'&:hover': { bgcolor: '#cfe0ff', color: '#ffffff' },
											'&.Mui-disabled': {
												bgcolor: 'grey.100',
												color: 'grey.400',
												boxShadow: 'none',
											},
										}}
										onClick={(e) => {
											e.stopPropagation()
											window.open(
												`https://www.ebay.de/sch/i.html?_nkw=${encodeURIComponent(
													num
												)}&_sacat=0&_from=R40&_trksid=p4624852.m570.l1313`,
												'_blank',
												'noopener,noreferrer'
											)
										}}>
										<StorefrontIcon fontSize='small' />
									</IconButton>
								</Badge>
							</span>
						</Tooltip>
					</Box>
				)
			},
		},
		{
			field: 'onShopify',
			headerName: 'onShopify',
			minWidth: 80,
			flex: 0.8,
			sortable: true,
			filterable: false,
			renderCell: (params) => {
				const num = params.row.articleNumber
				const hasNum = !!num
				const count = Number(params.value || 0)

				return (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'start',
							justifyContent: 'start',
							width: '100%',
						}}>
						<Tooltip title='MD-Teile Suche'>
							<span>
								<Badge
									badgeContent={count}
									color={count > 0 ? 'success' : 'default'}
									overlap='circular'
									anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
									sx={{
										'& .MuiBadge-badge': {
											fontSize: 10,
											height: 16,
											minWidth: 16,
											px: 0.5,
										},
									}}>
									<IconButton
										size='small'
										disabled={!hasNum}
										sx={{
											p: 0.5,
											bgcolor: '#ede9fe',
											color: '#5b21b6',
											boxShadow: 1,
											'&:hover': { bgcolor: '#c4b5fd', color: '#ffffff' },
											'&.Mui-disabled': {
												bgcolor: 'grey.100',
												color: 'grey.400',
												boxShadow: 'none',
											},
										}}
										onClick={(e) => {
											e.stopPropagation()
											window.open(
												`https://md-teile.de/search?q=${encodeURIComponent(
													num
												)}&options%5Bprefix%5D=last`,
												'_blank',
												'noopener,noreferrer'
											)
										}}>
										<HandymanIcon fontSize='small' />
									</IconButton>
								</Badge>
							</span>
						</Tooltip>
					</Box>
				)
			},
		},
		{
			field: 'URL',
			headerName: 'Image',
			minWidth: 50,
			flex: 0.8,
			sortable: true,
			filterable: false,
			renderCell: (params) => {
				const src = params.row.URL
				if (!src || src.length < 3) return null

				return (
					<Tooltip
						followCursor
						enterDelay={300}
						leaveDelay={0}
						slotProps={{
							tooltip: {
								sx: {
									p: 0,
									bgcolor: 'transparent',
									boxShadow: 3,
									borderRadius: 1,
									// make sure it floats above the DataGrid
									zIndex: (theme) => theme.zIndex.modal + 1,
								},
							},
						}}
						title={
							<Box
								sx={{
									borderRadius: 1,
									overflow: 'hidden',
									bgcolor: 'background.paper',
								}}>
								<img
									src={src}
									alt=''
									style={{ display: 'block', width: 280, height: 'auto' }}
									loading='lazy'
								/>
							</Box>
						}>
						<Box sx={{ cursor: 'zoom-in' }}>
							<img
								className='size-14 rounded-full object-cover'
								src={src}
								alt=''
								loading='lazy'
							/>
						</Box>
					</Tooltip>
				)
			},
		},
		{ field: 'category', headerName: 'Category', minWidth: 80, flex: 1 },
		{
			field: 'action',
			headerName: 'Actions',
			minWidth: 200,
			flex: 1.2,
			sortable: false,
			filterable: false,
			align: 'start', // header text only
			headerAlign: 'start',
			renderCell: (params) => {
				const num = params.row.articleNumber
				const kfzUrl = buildKfz24Url(num, params.row.articleType)
				return (
					<Box
						sx={{
							width: '100%',
							height: '100%', // fill the row height
							display: 'grid', // easiest centering
							gridAutoFlow: 'column',
							justifyContent: 'center', // horizontal center
							alignItems: 'center', // vertical center
							columnGap: 1, // spacing between buttons
						}}>
						<Tooltip title='Increase'>
							<IconButton
								size='small'
								sx={{
									bgcolor: 'success.main',
									color: 'common.white',
									'&:hover': { bgcolor: 'success.dark' },
									p: 0.5,
								}}
								onClick={() => updateQuantityHandler(params.row, 1)}>
								<AddIcon fontSize='small' />
							</IconButton>
						</Tooltip>

						<Tooltip title='Decrease'>
							<IconButton
								size='small'
								sx={{
									bgcolor: 'error.main',
									color: 'common.white',
									'&:hover': { bgcolor: 'error.dark' },
									p: 0.5,
								}}
								onClick={() => updateQuantityHandler(params.row, -1)}>
								<RemoveIcon fontSize='small' />
							</IconButton>
						</Tooltip>

						<IconButton
							size='small'
							component={Link}
							to={`/shop/${params.row.articleId}`}
							sx={{ p: 0.5 }}>
							<SearchIcon fontSize='small' />
						</IconButton>

						<Tooltip title='Search on PSH'>
							<IconButton
								size='small'
								sx={{
									p: 0.5,
									bgcolor: '#e0f2fe', // light blue
									color: '#0369a1',
									'&:hover': { bgcolor: '#38bdf8', color: '#ffffff' },
									boxShadow: 1,
									'&:hover': {
										bgcolor: 'info.main', // darker blue on hover
										color: 'common.white',
									},
								}}
								onClick={(e) => {
									e.stopPropagation()
									window.open(
										buildPshUrl(params.row.articleNumber),
										'_blank',
										'noopener,noreferrer'
									)
								}}>
								<TravelExploreIcon fontSize='small' />
							</IconButton>
						</Tooltip>

						{/* KFZ-Teile24 – orange; nur wenn Typ erkannt */}
						{kfzUrl && (
							<Tooltip title='KFZ-Teile24 Suche'>
								<IconButton
									size='small'
									sx={{
										p: 0.5,
										bgcolor: '#fff4e5',
										color: '#ff6e00',
										boxShadow: 1,
										'&:hover': { bgcolor: '#ffe3c4', color: '#fff' },
									}}
									onClick={(e) => {
										e.stopPropagation()
										window.open(kfzUrl, '_blank', 'noopener,noreferrer')
									}}>
									<DirectionsCarFilledIcon fontSize='small' />
								</IconButton>
							</Tooltip>
						)}
					</Box>
				)
			},
		},
	]

	const filterOptions = ['NotOnEbay', 'WithPicture', 'WithoutPicture', 'NoRegulator', 'InStock']

	const updateQuantityHandler = async (article, change) => {
		const newQuantity = article.quantity + change
		if (newQuantity < 0) return

    await api.put(`${databaseLocation}/api/updateQuantity`, {
			quantity: newQuantity,
			articleId: article.articleId,
			clientAccessToken: 'lima454#',
			username: user.username,
		})
			.then((res) => {
				createLogEntry(
					`updated the quantity of article "${article.articleNumber}" (${article.articleId}) from ${article.quantity} to ${newQuantity}`
				)
				article.quantity = newQuantity
				updateArticleInList(article)
			})
			.catch((e) => {
				console.log(e)
			})
	}

	const updateArticleInList = (article) => {
		const newList = articleList.map((item) => {
			if (item.articleId === article.articleId) {
				const updatedItem = {
					...item,
					quantity: article.quantity,
				}
				return updatedItem
			}
			return item
		})
		setArticleList(newList)
	}

	return (
		<div className='w-full m-4'>
			<div className='flex flex-col md:flex-row gap-4 mb-4'>
				{/* Search Input */}
				<input
					type='text'
					placeholder='Search..'
					value={searchText}
					onChange={(e) => setSearchText(e.target.value)}
					className='border border-gray-300 rounded p-2 w-full md:w-auto'
				/>

				{/* Filter Dropdown */}
				<Dropdown
					options={filterOptions}
					selectedOptions={selectedFilters}
					onSelect={handleFilter}
				/>
			</div>

			{/* Responsive Data Grid */}
			<Box
				sx={{
					width: '100%',
					height: 'calc(100vh - 200px)',
					'& .MuiDataGrid-root': {
						border: 'none', // Remove borders for a cleaner look
					},
					'& .MuiDataGrid-cell': {
						whiteSpace: 'normal',
						wordWrap: 'break-word',
					},
					'& .MuiDataGrid-columnHeaders': {
						backgroundColor: '#f7f7f7',
					},
					overflowX: 'auto', // Enable horizontal scrolling on smaller screens
				}}>
				<DataGrid
					rowHeight={56}
					loading={loading}
					rows={filteredList}
					getRowId={(row) => row.articleId}
					columns={columns}
					disableColumnResize={false} // ensure not disabled
					pageSize={15}
					rowsPerPageOptions={[15]}
					disableSelectionOnClick
					columnBuffer={2} // Optimizes performance and responsiveness
				/>
			</Box>
		</div>
	)
}
